import UmTableRole from './src/main'

UmTableRole.install = function(Vue) {
  Vue.component(UmTableRole.name, UmTableRole)
}

export default UmTableRole
